import { render, staticRenderFns } from "./U_VoiceBusiness.vue?vue&type=template&id=1a38e238&scoped=true&"
import script from "./U_VoiceBusiness.vue?vue&type=script&lang=js&"
export * from "./U_VoiceBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38e238",
  null
  
)

export default component.exports